module.exports = __webpack_public_path__ + "img/hiring.864402ce.svg";